export default __webpack_public_path__ + "static/media/teacherLicence.00ffbd8e.svg";